<template>
	<div id="app" @click="clearSeconds">
		<router-view></router-view>
	</div>
</template>

<script>
	import '../static/css/antd.min.css';
	import '../static/css/common.css';
	import '../static/css/index.css';
	export default {
		name: 'app',
		components: {},
		data() {
			return {
				seconds: 0
			}
		},
		mounted() {
			setInterval(this.go, 1000)
		},
		methods: {
			go() {
				this.seconds = this.seconds + 1
				if (this.seconds >= 1800) {
					this.$router.push('/')
					this.seconds = 0
				}
			},
			clearSeconds() {
				this.seconds = 0
			}
		}
	}
</script>

<style>
	/* 	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
	} */
</style>
